namespace Gordic.Adm.WebControls {

    export interface IGAdmSigSelectInput {
        data?: {
            /** data souboru */
            fileData?: any,
            /** název souboru */
            fileName?: string,
            /** vizuální pozice */
            signaturePositions: any[];
        },
        filePreviewLoadOptions?: IGFilePreviewLoadOptions,
        sigSelectOptions?: Pick<Gin.WebClient.IGSigSelectOptions, "drawingStyle">
    }

    /**
     * GAdmSignPlacing - Content pro otevření komponenty pro vizuální umístění podpisu
     * - autor původního kódu: vmaca (Wfl\SignModule\Dialogs\GWflSignPlacing.ts)
     * 
     * @author thazmuka
     * @since 484.1.0.92
     */
    @Decorators.gcontent
    export class GAdmSignPlacing extends GContentBase implements IGClientContent {

        uid = "gadmsign#"
        title = "jres:32000151" //RC 32000151 : Umístění podpisu

        prepareContent(inputDto: IGAdmSigSelectInput) {

            let signaturePositions = inputDto.data?.signaturePositions;

            const that = this;

            this.actions.addRange([
                {
                    name: "actSigSave", icon: "gi-save", caption: "jres:32000161", run: function () { //RC 32000161 : Uložit a zavřít
                        if (inputDto.data) {
                            var SignaturePositions = that.element.gsigselect("getSignatures");
                            that.tryClose(SignaturePositions);
                        }
                    }
                },
                { name: "actSigClose", icon: "gi-window-close", caption: GDlg.mbbClose.text, run: () => { this.tryClose(null); } }
            ]);

            this.element.gfilepreview({
                engineOptions: {
                    pdfEngine: { zoomMode: Components.FilePreview.GPdfEngineZoomMode.Height }
                },
                menubardone: (ev, ctx: { element: JQuery }) => {
                    if (ctx.element) {
                        ctx.element.addClass('ui-dialog-toolbar');
                    }
                },
                prerender: (ev, ctx) => {
                    if (ctx && ctx.data && ctx.data.Positions && ctx.data.DefaultSignature) {
                        this.element.gsigselect("option", "signatures", ctx.data.Positions);
                        this.element.gsigselect("option", "defaultSignature", ctx.data.DefaultSignature);
                    }
                },
                modifymenubar: (ev, ctx) => { //RC 31750006 : Probíhá vykreslení souboru ...
                    let spliceOptions: [number, number, ...MenuParams[]] = [0, 0];

                    let closeMenu: MenuParams = { type: "action", action: this.actions.actSigClose!, captionVisible: "never", visiblePriority: 2 };
                    let separator: MenuParams = { id: "openSeparator", type: "separator", visiblePriority: 2 };

                    if (ctx.isError) {
                        spliceOptions.push(closeMenu);
                        if (ctx.menuBar.length > 0) spliceOptions.push(separator);
                    } else {
                        spliceOptions.push({ type: "action", action: this.actions.actSigSave!, captionVisible: "never", primary: true, visiblePriority: 2 });
                        spliceOptions.push(closeMenu);
                        if (ctx.menuBar.length > 0) spliceOptions.push(separator);
                    }

                    ctx.menuBar.splice.apply(ctx.menuBar, spliceOptions);
                }
            }).gsigselect(inputDto?.sigSelectOptions);

            this.element.gfilepreview("displayFile", inputDto.data?.fileData, inputDto.data?.fileName || 'jres:32000154', { extension: "pdf", isBase64: true }); //RC 32000154 : Soubor

            if (signaturePositions != null) {
                var array: any = [];
                array.push(signaturePositions);
                this.element.gsigselect("option", "signatures", array);
                this.showFlash({
                    label: "jres:32000152", state: 'info' //RC 32000152 : Nyní máte možnost změnit umístění podpisu
                })
            } else {
                this.showFlash({ label: "jres:32000153", state: 'info' }) //RC 32000153 : Zvolte prosím nové umístění podpisu.
            }

            this.element.gsigselect("start");
        }

        closing(retVal) {
            return $.Deferred().resolve(retVal || null).promise();
        }

    }
}